import { createMutationHelper } from '@utils/swr'
import { type PlatformSdkOtpVerificationRequest } from '../../../types/apiRequest'
import { type OtpVerificationResponse } from '../../../types/apiResponse'
import { type CosignApis } from '../../../types/apis'

const {
  useMutation,
} = createMutationHelper<CosignApis['post']['otpVerification'], OtpVerificationResponse, PlatformSdkOtpVerificationRequest>({
  client: 'cosign',
  key: '/api/platform-sdk/otp-verification',
  fetcher: (url, { arg, client }) => {
    return client.post(url, arg)
  },
})

export const useRequestOtpVerification = useMutation
